"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLogo = exports.AppLogoDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var use_components_1 = require("../../hooks/use-components");
var shape_logo_1 = require("../elements/shape-logo");
exports.AppLogoDefaultProps = {};
// -------- Components -------->
var AppLogo = function (props) {
  var className = props.className;
  var components = (0, use_components_1.useComponents)();
  var Logo = components.Logo || shape_logo_1.ShapeLogo;
  return react_1.default.createElement(Logo, {
    className: className
  });
};
exports.AppLogo = AppLogo;
exports.AppLogo.defaultProps = exports.AppLogoDefaultProps;